import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export default client;

export function formatApiError(err) {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;

  // Netzwerk / Server nicht erreichbar
  if (err?.code === "ERR_NETWORK" || err?.message === "Network Error") {
    return "Ich kann Nora gerade nicht erreichen. Bitte probier es gleich noch einmal.";
  }

  // HTTP-Statusfehler ohne konkrete Backend-Meldung → freundliche Standard-Antwort
  if (detail == null) {
    if (status === 401) return "Bitte melde dich noch einmal an.";
    if (status === 403) return "Dafür fehlt dir leider die Berechtigung.";
    if (status === 404) return "Der Eintrag wurde nicht gefunden.";
    if (status === 409) return "Dieser Eintrag existiert bereits.";
    if (status >= 500) return "Bei Nora ist gerade etwas schiefgelaufen. Bitte gleich noch einmal versuchen.";
    return err?.message || "Etwas ist schiefgelaufen. Bitte probier es gleich noch einmal.";
  }

  const translate = (raw) => {
    if (!raw) return raw;
    // Häufige Pydantic/FastAPI-Meldungen freundlich übersetzen
    if (/field required/i.test(raw)) return "Bitte fülle alle Pflichtfelder aus.";
    if (/value is not a valid/i.test(raw) || /invalid/i.test(raw)) return "Bitte prüfe deine Eingaben.";
    if (/not found/i.test(raw) || /nicht gefunden/i.test(raw)) return raw.match(/nicht gefunden/i) ? raw : "Der Eintrag wurde nicht gefunden.";
    if (/validation error/i.test(raw)) return "Bitte prüfe deine Eingaben.";
    return raw;
  };

  if (typeof detail === "string") return translate(detail);
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? translate(e.msg) : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return translate(detail.msg);
  return translate(String(detail));
}
